const namespace = "uicore";
import AppConfig from "@/_config/application-config"
import childRoutes from "./routes"
import BrowserStorage from "@/_util/storage-modes.browser-storage";

const localStorage = new BrowserStorage(namespace);
const sessionStorage = new BrowserStorage(namespace, true);

const appConfig = {
  name: "Home",
  description: null,
  namespace,
  version: "0.1.1",
  icon: "mdi-home",
  accentColor: "#009CDE",
  parentRoute: "/home",
  defaultRoute : "overview",
  childRoutes,
  component: () => import( /* webpackChunkName: "home-parent" */ "@/apps/home/Application.vue"),
  navigation: [
  ],
  settings : {},
  store : {},

}

export default AppConfig.merge(appConfig);
